<template>
  <div>
    <register-terminal-tef
      class="mb-6"
      @configure="openInitialIntegration"
    />
    <show-terminals-tef ref="ShowTerminalsTef" />
    <v-dialog v-model="initialIntegrationDialogOpen" max-width="900">
      <add-integration-bulk-tef
        v-if="selectedCompany"
        :key="`initial-${selectedCompany.IdCompania}`"
        :company="selectedCompany"
        :creating-terminal="true"
        @close="initialIntegrationDialogOpen = false"
        @saved="onInitialIntegrationSaved"
      />
    </v-dialog>
  </div>
</template>
<script>
  export default {
    components: {
      RegisterTerminalTef: () => import('./components/RegisterTerminalTef'),
      ShowTerminalsTef: () => import('./components/ShowTerminalsTef'),
      AddIntegrationBulkTef: () => import('./components/AddIntegrationBulkTef'),
    },
    data () {
      return {
        initialIntegrationDialogOpen: false,
        selectedCompany: null,
      }
    },
    methods: {
      openInitialIntegration (company) {
        this.selectedCompany = {
          ...company,
          companyName: company.text,
        }
        this.initialIntegrationDialogOpen = true
      },
      async onInitialIntegrationSaved () {
        this.initialIntegrationDialogOpen = false
        await this.$refs.ShowTerminalsTef.loadTerminals()
      },
    },
  }
</script>
